// One canonical representation for developer-per-application budget scopes.
export const gatewaySubjectApplicationId = (subject: string, app: string): string => JSON.stringify([subject, app])

export const parseGatewaySubjectApplicationId = (value: string): [string, string] | null => {
  try {
    const parsed: unknown = JSON.parse(value)
    if (
      !Array.isArray(parsed) ||
      parsed.length !== 2 ||
      parsed.some((part) => typeof part !== "string" || part.length === 0)
    )
      return null
    const [subject, app] = parsed as [string, string]
    return gatewaySubjectApplicationId(subject, app) === value ? [subject, app] : null
  } catch {
    // Invalid external policy IDs are rejected at the boundary.
    return null
  }
}
